import { Component, OnInit, ViewChild, ElementRef, Input, ViewChildren, Renderer2, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { StateService, AuthService, AuctionService, AuctionLotService, MyAuctionLotService } from '../../../services';
import { FormFunctions } from '../../../functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { } from '../../../shared/modals';
import { AuctionLotSearchSortType } from 'src/app/models/auction-lot-search-sort-type';
import { AppConfig } from 'src/app/config';
import { fadeAnimation } from 'src/app/shared/animations';
import { AuctionModel } from 'src/app/models';

@Component({
    selector: 'page-auction-search',
    styleUrls: ['./page-auction-search.component.scss'],
    templateUrl: './page-auction-search.component.html',
    animations: [fadeAnimation],
})
export class PageAuctionSearchComponent implements OnInit {
    processing: boolean = false;
    initialized: boolean = false;
    vendorView: boolean = false;
    loggedIn: boolean = false;

    sortByOptions: any[] = [
        { Id: AuctionLotSearchSortType.LotNumber, Title: 'Lot Number' },
        { Id: AuctionLotSearchSortType.UnitPriceDescending, Title: 'Estimate Price (High to Low)' },
        { Id: AuctionLotSearchSortType.UnitPriceAscending, Title: 'Estimate Price (Low to High)' },
        { Id: AuctionLotSearchSortType.WineryAscending, Title: 'Winery (A to Z)' },
        { Id: AuctionLotSearchSortType.WineryDescending, Title: 'Winery (Z to A)' },
        // { Id: AuctionLotSearchSortType.MaxBid, Title: 'Max Bid' },
        // { Id: AuctionLotSearchSortType.VintageAscending, Title: 'Vintage (Old to New)' },
        // { Id: AuctionLotSearchSortType.VintageDescending, Title: 'Vintage (New to Old)' },
    ];

    @ViewChild("pager") pager: ElementRef;
    @ViewChild("list") list: ElementRef;

    constructor(public router: Router,
        private appConfig: AppConfig,
        private activatedRoute: ActivatedRoute,
        public stateService: StateService,
        private modalService: NgbModal,
        public authService: AuthService,
        public auctionService: AuctionService,
        public auctionLotService: AuctionLotService,
        public myAuctionLotService: MyAuctionLotService,
        public formFunctions: FormFunctions
    ) {
        var me = this;

        me.loggedIn = me.stateService.userModel != null;
        me.stateService.userModel$.subscribe(data => {
            me.loggedIn = data != null;
        });
    }

    get Auction(): AuctionModel {
        return this.auctionService.auctions?.find(x => x.Id == this.auctionLotService.auctionId);
    }

    ngOnInit() {
        let me = this;
        // Wait until the default auction is loaded
        me.initialized = false;
        me.auctionService.CurrentAuction().subscribe(data => {
            if (me.activatedRoute.snapshot.params.auctionId) {
                me.auctionLotService.auctionId = Number(me.activatedRoute.snapshot.params.auctionId);
                me.OnAuctionChange(false);
            } else {
                me.OnAuctionChange(false);
            }
            me.initialized = true;
        });
    }

    OnAuctionChange(redirect: boolean) {
        let me = this;

        // Handles displaying auction with no URL param
        if (!me.auctionLotService.auctionId && me.auctionService.auction) {
            me.auctionLotService.auctionId = me.auctionService.auction.Id;
        }

        if (me.auctionLotService.auctionId || me.auctionService.auction) {
            me.myAuctionLotService.auctionId = me.auctionLotService.auctionId;

            me.LoadData();
            me.auctionLotService.AuctionChanged();
            me.auctionLotService.Initialize();

            if (redirect) me.router.navigate(['/auction', me.auctionLotService.auctionId || me.auctionService.auction.Id]);
        }
    }

    LoadData() {
        let me = this;
        me.auctionLotService.searchStream$.next(me.auctionLotService.filters);
    }

    SetPage(page: number) {
        // console.log('SetPage', page);
        this.auctionLotService.page = page;
        this.LoadData();
        this.pager.nativeElement.scrollIntoViewIfNeeded(); // scroll back to top
    }

    Updated() {
        // console.log('Updated');
        this.auctionLotService.page = 1;
        this.LoadData();
    }

    Cleared() {
        // console.log('Cleared');
        this.auctionLotService.filters = this.auctionLotService.GetDefaultFilters();
        this.auctionLotService.page = 1;
        this.LoadData();
    }

    changeVendorView() {
        let me = this;

        me.auctionLotService.filters.vendorView = me.vendorView;
        me.LoadData();
    }
}
